module.exports = __webpack_public_path__ + "img/KL.f6fe83c3.png";